import * as actionTypes from '../Register_action.types';

const initialState = {
  loggingIn: false,
  generateForm: [],
  error: null,
  message: '',
};


const generateFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CREATE_GENERATE_FORM_REQUEST:
    case actionTypes.UPLOAD_GENERATED_FORM_REQUEST:
    case actionTypes.GET_GENERATED_FORM_REQUEST:
    case actionTypes.UPDATE_GENERATED_FORM_REQUEST:
    case actionTypes.DELETE_GENERATED_FORM_REQUEST:
      case actionTypes.GENERATED_FORM_DOWNLOAD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.CREATE_GENERATE_FORM_SUCCESS:
    case actionTypes.UPLOAD_GENERATED_FORM_SUCCESS:
    case actionTypes.GET_GENERATED_FORM_SUCCESS:
    case actionTypes.UPDATE_GENERATED_FORM_SUCCESS:
    case actionTypes.DELETE_GENERATED_FORM_SUCCESS:
      case actionTypes.GENERATED_FORM_DOWNLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };
    case actionTypes.CREATE_GENERATE_FORM_FAILURE:
    case actionTypes.UPLOAD_GENERATED_FORM_FAILURE:
    case actionTypes.GET_GENERATED_FORM_FAILURE:
    case actionTypes.UPDATE_GENERATED_FORM_FAILURE:
    case actionTypes.DELETE_GENERATED_FORM_FAILURE:
    case actionTypes.GENERATED_FORM_DOWNLOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default generateFormReducer
